import $ from 'jquery';
import moment from 'moment';
import Alpine from 'alpinejs';
import 'bootstrap';
import 'google-maps';
import 'jquery-ui-bundle';
import 'datatables.net-bs4';
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-responsive-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.min.css';

window.$ = window.jQuery = $;
window.moment = moment;
window.Alpine = Alpine;

Alpine.start();
